export default "__VITE_ASSET__D0t0i8zL__"